import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  IconCircleMinus,
  IconCirclePlus,
  IconMinus,
  IconPlus,
} from "@tabler/icons";
import { useEffect, useMemo, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import first
import { axiosInstance } from "src/api/axios";
import PageContainer from "src/components/container/PageContainer";

function AddProducts() {
  const [baseParams, setBaseParams] = useState([0]);
  const [parameterslength, setParametersLength] = useState([1]);
  const [parameters, setParameters] = useState([]);
  const [levels, setLevels] = useState(1);
  const [levelMeta, setLevelMeta] = useState([
    { description: "", message: "", title: "", amount: "", level: 1 },
  ]);
  const [files, setFiles] = useState([]);

  const [category, setCategory] = useState([]);
  const [eligibiltylist, seteligibiltylist] = useState("");
  const [ruleslist, setruleslist] = useState("");
  const [featureslist, setfeatureslist] = useState("");
  const [steps, setsteps] = useState("");
  const [error, setError] = useState("");
  // const [user, setUser] = useState({});

  useMemo(() => {
    axiosInstance.get("/users").then((res) => {
      if (res.status < 210) {
        let _ = res.data;
        if (!_?.role.includes("admin")) {
          window.location.href = "/";
        }
      }
    });
  }, []);
  useEffect(() => {
    axiosInstance.get("/categories").then((categories) => {
      console.log(categories);
      if (typeof categories.data === "object") {
        setCategory([...categories.data]);
      }
    });
  }, []);

  const [productData, setProductData] = useState({
    baseUrlParams: [],
    category: "",
    images: [],
    title: "",
    subtitle: "",
    info: "",
    publisher: "",
    levels: levels || (levelMeta && levelMeta.length ? levelMeta.length : 1),
    levelMeta: [],
    publisher_amount: "",
    expiry: "",
    earntype: "Earn Upto",
    lead_share_message: "",
    lead_share_image: "",
    isPercentage: false,
    status: "Active",
    redirect_url: "",
    parameters: {},
    description: "",
  });

  const onTextAreaValueChange = (value, setValue) => {
    let formatted = value.target.value;
    if (formatted[formatted.length - 1] === "\n") {
      formatted = formatted.slice(0, formatted.length - 1) + "\n• ";
    }

    setValue(formatted);
  };

  const updateProductData = (key, value) => {
    setProductData((product) => {
      product[key] = value;
      return { ...product };
    });
  };

  useEffect(() => {}, [productData]);
  const submitProduct = () => {
    setError("");
    const rawData = {
      ...productData,
      features: featureslist.replaceAll("•", "").split("/n"),
      rules: ruleslist.replaceAll("•", "").split("/n"),
      steps: steps.replaceAll("•", "").split("/n"),
      eligibilty: eligibiltylist.replaceAll("•", "").split("/n"),
    };
    if (levelMeta.length) {
      for (let i in levelMeta) {
        if (
          !levelMeta[i].description ||
          !levelMeta[i].action_header ||
          !levelMeta[i].title ||
          !levelMeta[i].amount
        ) {
          alert("Please fill all the fields in level meta");
          return;
        }
      }
    }
    if (rawData["levels"] !== rawData["levelMeta"].length) {
      rawData["levels"] = rawData["levelMeta"].length;
    }
    const temp_parameters = {};
    for (let i of parameterslength) {
      if (parameters[i]) {
        temp_parameters[parameters[i]] = "";
      }
    }
    rawData["parameters"] = JSON.stringify(temp_parameters);
    let payload = new FormData();
    for (let i of Object.entries(rawData)) {
      if (i[0] === "images") {
        for (let j of files) {
          payload.append("images", j);
        }
      } else if (i[0] === "baseUrlParams") {
        payload.append("baseUrlParams", JSON.stringify(i[1]));
      } else {
        payload.append(i[0], i[1]);
      }
    }
    console.log(rawData, payload);
    axiosInstance
      .post("/product", payload)
      .then((res) => {
        console.log(res.data);
        if (res.status < 210) {
          toast.success("Product Added successfully");
          window.location.href = "/admin/";
        } else {
          // alert('something went wrong');
          setError(
            res?.response?.data?.message ||
              res?.response?.message ||
              res?.message ||
              res.status
          );
        }
      })
      .catch((error) => {
        if (error) {
          console.log(error.status, error.message, error.response, error.data);
          console.log(Object.keys(error));
          setError(
            error?.response?.data?.message || error?.message || error.status
          );
        }
      });
  };
  const onKeyPress = (value, setValue) => {
    let formatted = value.target.value;
    if (value.keyCode === 8 && formatted[formatted.length - 1] === "•") {
      formatted = formatted.slice(0, formatted.length - 1);
      console.log(value);
    }
    setValue(formatted);
  };

  useEffect(() => {
    updateProductData("levelMeta", JSON.stringify(levelMeta));
  }, [levelMeta]);
  return (
    <PageContainer
      title="Create Offer Products"
      description="this is Products Creation page for admins"
    >
      <Card
        variant="outlined"
        style={{ boxShadow: "0px 0px 10px rgba(0,0,0,0.1)" }}
      >
        <CardContent>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="title"
                  label="Title"
                  variant="outlined"
                  onChange={(e) => updateProductData("title", e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="subtitle"
                  label="Subtitle"
                  variant="outlined"
                  onChange={(e) =>
                    updateProductData("subtitle", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="shortInfo"
                  label="Short Info [upto 50-70 words]"
                  variant="outlined"
                  multiline
                  onChange={(e) => updateProductData("info", e.target.value)}
                />
              </Grid>

              <Grid item xs={12}>
                <Stack direction="row" spacing={1} my={1}>
                  <TextField
                    fullWidth
                    id="redirect_url"
                    label="Redirect URL"
                    prefix="https://"
                    sx={{ flex: 1 }}
                    onChange={(e) =>
                      updateProductData("redirect_url", e.target.value)
                    }
                    variant="outlined"
                  />

                  <Stack direction="column" spacing={1} alignItems="center">
                    {baseParams.map((i) => {
                      return (
                        <TextField
                          required
                          id={`baseParams-${i}`}
                          label={`Base Params -${i}`}
                          key={i + 1}
                          onChange={(e) =>
                            setProductData((data) => {
                              data.baseUrlParams[i] = e.target.value;
                              return { ...data };
                            })
                          }
                          variant="outlined"
                        />
                      );
                    })}
                    <Stack direction={"row"} spacing={5}>
                      <IconCircleMinus
                        style={{ width: 36 }}
                        onClick={() =>
                          setBaseParams((i) =>
                            Number(i.length) === 1 ? [...i] : i.pop() && [...i]
                          )
                        }
                      />
                      <IconCirclePlus
                        style={{ width: 36 }}
                        onClick={() => setBaseParams((i) => [...i, i.length])}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack direction={"row"} spacing={3}>
                  <FormControl sx={{ flex: 1 }}>
                    <InputLabel id="category-label">Category</InputLabel>
                    <Select
                      required
                      labelId="category-label"
                      id="category"
                      label="Category"
                      sx={{ flex: 2 }}
                      value={productData.category || category[0]}
                      onChange={(e) =>
                        updateProductData("category", e.target.value)
                      }
                    >
                      {category
                        ? category.map((cat) => {
                            return (
                              <MenuItem key={cat.title} value={cat.title}>
                                {cat.title}
                              </MenuItem>
                            );
                          })
                        : null}
                    </Select>
                  </FormControl>
                  <TextField
                    id="publisher"
                    label="Publisher"
                    onChange={(e) =>
                      updateProductData("publisher", e.target.value)
                    }
                    variant="outlined"
                  />
                  <TextField
                    fullWidth
                    sx={{ maxWidth: "185px" }}
                    id="product_amount"
                    label="Publisher Amount"
                    type="number"
                    onChange={(e) =>
                      updateProductData("publisher_amount", e.target.value)
                    }
                    variant="outlined"
                  />
                </Stack>
              </Grid>

              <Grid item={12} width={"100%"}>
                <Stack direction={"row"} spacing={2}>
                  <TextField
                    fullWidth
                    id="lead_share_message"
                    label="Share Message"
                    onChange={(e) =>
                      updateProductData("lead_share_message", e.target.value)
                    }
                    variant="outlined"
                    multiline
                  />
                  <TextField
                    fullWidth
                    id="lead_share_image"
                    label="Share Image Link"
                    onChange={(e) =>
                      updateProductData("lead_share_image", e.target.value)
                    }
                    variant="outlined"
                  />
                  <TextField
                    fullWidth
                    id="expiry"
                    label="Expiry [ in Days]"
                    type="number"
                    sx={{ maxWidth: "185px" }}
                    inputProps={{
                      sx: {
                        "::-webkit-inner-spin-button": { display: "none" },
                        "::-webkit-outer-spin-button": { display: "none" },
                      },
                    }}
                    onChange={(e) =>
                      updateProductData("expiry", e.target.value)
                    }
                    variant="outlined"
                  />
                </Stack>
              </Grid>

              <Grid item={12} sx={{ width: "100%" }}>
                <Stack direction={"row"} spacing={2}>
                  <FormControl fullWidth>
                    <InputLabel id="status-label">Status</InputLabel>
                    <Select
                      labelId="status-label"
                      id="status"
                      label="Status"
                      defaultValue={"Active"}
                      value={productData.status || "Active"}
                      onChange={(e) =>
                        updateProductData("status", e.target.value)
                      }
                    >
                      <MenuItem value={"Active"}>Active</MenuItem>
                      <MenuItem value={"Paused"}>Paused</MenuItem>
                      <MenuItem value={"Stopped"}>Stopped</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="earntype-label">Earntype</InputLabel>
                    <Select
                      labelId="earntype-label"
                      id="earntype"
                      label="Earntype"
                      defaultValue={"Earn Upto"}
                      value={productData.earntype || "Earn Upto"}
                      onChange={(e) =>
                        updateProductData("earntype", e.target.value)
                      }
                    >
                      <MenuItem value={"Earn Upto"}>Earn Upto</MenuItem>
                      <MenuItem value={"Earn Flat"}>Earn Flat</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    id="trackingTime"
                    label="Tracking time"
                    onChange={(e) =>
                      updateProductData("trackingTime", e.target.value)
                    }
                    variant="outlined"
                  />
                  <TextField
                    fullWidth
                    id="earnUpto"
                    label="Earn Upto"
                    onChange={(e) =>
                      updateProductData("earnUpto", e.target.value)
                    }
                    variant="outlined"
                    type="number"
                    inputProps={{
                      sx: {
                        "::-webkit-inner-spin-button": { display: "none" },
                        "::-webkit-outer-spin-button": { display: "none" },
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    id="payment"
                    label="Payment duration [ in Days]"
                    onChange={(e) =>
                      updateProductData("payment", e.target.value)
                    }
                    variant="outlined"
                  />
                  <FormControlLabel
                    sx={{
                      display: "block",
                      width: "75%",
                    }}
                    control={
                      <Checkbox
                        checked={productData.isPercentage}
                        onClick={() =>
                          updateProductData(
                            "isPercentage",
                            !productData.isPercentage
                          )
                        }
                        color="primary"
                      />
                    }
                    label="Is Percentage"
                  />
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Stack>
                  <label>Parameters</label>
                  {parameterslength.map((index) => {
                    return (
                      <Stack direction={"row"} key={index}>
                        <TextField
                          fullWidth
                          id={`key_${index}`}
                          label={"Key " + index}
                          sx={{ flex: 1 }}
                          onChange={(e) => {
                            setParameters((keys) => {
                              let newvalue = [...keys];
                              newvalue[index] = e.target.value;
                              return [...newvalue];
                            });
                          }}
                          variant="outlined"
                        />
                      </Stack>
                    );
                  })}
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    spacing={3}
                    width={"100%"}
                  >
                    <IconPlus
                      onClick={() => {
                        setParametersLength((p) => {
                          let params = [...p];
                          if (params.length < 10) {
                            params.push(params.length + 1);
                          }
                          return [...params];
                        });
                      }}
                    />
                    <IconMinus
                      onClick={() => {
                        setParametersLength((p) => {
                          let params = [...p];
                          if (params.length > 1) {
                            params.pop(params.length - 1);
                          }
                          return [...params];
                        });
                      }}
                    />
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack
                  my={1}
                  p={2}
                  alignItems="center"
                  border={1}
                  borderColor={"#8769DC"}
                  borderRadius={5}
                  spacing={3}
                >
                  <Stack direction={"row"} spacing={2}>
                    <TextField
                      type="number"
                      value={levels}
                      onChange={(e) => {
                        updateProductData("levels", e.target.value || 1);
                        setLevels(
                          e.target.value ||
                            (levelMeta && levelMeta.length
                              ? levelMeta.length
                              : 1)
                        );
                      }}
                      label="Levels"
                      variant="outlined"
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (!levels || levels < 1) {
                          setLevels(levelMeta.length || 1);
                        }
                        let temp = [...levelMeta];
                        if (levels < temp.length) {
                          temp = temp.slice(0, levels);
                        }

                        for (let i = 0; i < levels - temp.length; i++) {
                          temp.push({
                            description: "",
                            action_header: "",
                            title: "",
                            amount: "",
                            level: i + 1,
                          });
                        }
                        temp.forEach((level, index) => {
                          level.level = index + 1;
                        });
                        setLevelMeta(temp);
                        updateProductData("levelMeta", JSON.stringify(temp));
                        updateProductData("levels", temp.length);
                      }}
                    >
                      Add Levels
                    </Button>
                  </Stack>
                  <Stack spacing={2}>
                    {levelMeta.map((level, index) => {
                      return (
                        <Stack key={index} direction={"row"} spacing={2}>
                          <TextField
                            label={`Level ${index + 1} Title`}
                            value={level.title}
                            onChange={(e) => {
                              let temp = [...levelMeta];
                              temp[index].title = e.target.value;
                              setLevelMeta(temp);
                            }}
                            variant="outlined"
                          />
                          <TextField
                            label={`Level ${index + 1} Description`}
                            value={level.description}
                            onChange={(e) => {
                              let temp = [...levelMeta];
                              temp[index].description = e.target.value;
                              setLevelMeta(temp);
                            }}
                            variant="outlined"
                          />
                          <TextField
                            label={`Action Header`}
                            value={level.action_header}
                            onChange={(e) => {
                              let temp = [...levelMeta];
                              temp[index].action_header = e.target.value;
                              setLevelMeta(temp);
                            }}
                            variant="outlined"
                          />
                          <TextField
                            label={`Level ${index + 1} Amount`}
                            type={"number"}
                            value={level.amount}
                            onChange={(e) => {
                              let temp = [...levelMeta];
                              temp[index].amount = e.target.value;
                              setLevelMeta(temp);
                            }}
                            variant="outlined"
                          />
                        </Stack>
                      );
                    })}
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack
                  direction="column"
                  spacing={1}
                  my={1}
                  p={2}
                  alignItems="center"
                  border={1}
                  borderColor={"#8769DC"}
                  borderRadius={5}
                >
                  <label
                    htmlFor="main-image"
                    style={{
                      width: "80%",
                      background: "#eee",
                      borderRadius: "10px",
                      minHeight: "180px",
                      display: "flex",
                      flexFlow: "column",
                      alignItems: "center",
                    }}
                  >
                    <Stack
                      direction="column"
                      spacing={2}
                      alignItems={"center"}
                      my={2}
                      py={3}
                    >
                      <h2>Upload Main Image</h2>
                      {productData.images?.length ? (
                        productData.images.map((image, index) => {
                          console.log(image);
                          return (
                            <div
                              key={index}
                              style={{
                                position: "relative",
                                padding: 2,
                                background: "#ff84",
                                borderRadius: 10,
                                width: "auto",
                                pointerEvents: "auto",
                              }}
                            >
                              <div>
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt={`${index}`}
                                  style={{
                                    borderRadius: 10,
                                    width: "100px",
                                  }}
                                />
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <>
                          <span>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M1.99967 9.33337C2.36786 9.33337 2.66634 9.63185 2.66634 10V12.6667C2.66634 12.8435 2.73658 13.0131 2.8616 13.1381C2.98663 13.2631 3.1562 13.3334 3.33301 13.3334H12.6663C12.8431 13.3334 13.0127 13.2631 13.1377 13.1381C13.2628 13.0131 13.333 12.8435 13.333 12.6667V10C13.333 9.63185 13.6315 9.33337 13.9997 9.33337C14.3679 9.33337 14.6663 9.63185 14.6663 10V12.6667C14.6663 13.1971 14.4556 13.7058 14.0806 14.0809C13.7055 14.456 13.1968 14.6667 12.6663 14.6667H3.33301C2.80257 14.6667 2.29387 14.456 1.91879 14.0809C1.54372 13.7058 1.33301 13.1971 1.33301 12.6667V10C1.33301 9.63185 1.63148 9.33337 1.99967 9.33337Z"
                                fill="#3C50E0"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M7.5286 1.52864C7.78894 1.26829 8.21106 1.26829 8.4714 1.52864L11.8047 4.86197C12.0651 5.12232 12.0651 5.54443 11.8047 5.80478C11.5444 6.06513 11.1223 6.06513 10.8619 5.80478L8 2.94285L5.13807 5.80478C4.87772 6.06513 4.45561 6.06513 4.19526 5.80478C3.93491 5.54443 3.93491 5.12232 4.19526 4.86197L7.5286 1.52864Z"
                                fill="#3C50E0"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M7.99967 1.33337C8.36786 1.33337 8.66634 1.63185 8.66634 2.00004V10C8.66634 10.3682 8.36786 10.6667 7.99967 10.6667C7.63148 10.6667 7.33301 10.3682 7.33301 10V2.00004C7.33301 1.63185 7.63148 1.33337 7.99967 1.33337Z"
                                fill="#3C50E0"
                              />
                            </svg>
                          </span>
                          <p>
                            <span className="text-primary">
                              Click to upload or drag and drop
                            </span>
                          </p>
                        </>
                      )}
                    </Stack>
                    <input
                      style={{
                        display: "none",
                        paddingY: "45px",
                        width: "100%",
                      }}
                      id="main-image"
                      label="Main Image"
                      multiple
                      accept="image/*"
                      type="file"
                      onChange={(event) => {
                        const selectedFiles = event?.target?.files;
                        console.log(selectedFiles);
                        if (selectedFiles) {
                          if (
                            selectedFiles.length + productData.images.length >
                            4
                          ) {
                            toast.error("Cannot Upload more than 4 images");
                            return;
                          }

                          setProductData((prevState) => {
                            if (!Array.isArray(prevState.images)) {
                              prevState.images = [];
                            }
                            return {
                              ...prevState,
                              images: Array.from(selectedFiles),
                            };
                          });
                          setFiles(event.target.files);
                        }
                      }}
                    />
                  </label>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="description"
                  label="Description"
                  variant="outlined"
                  multiline
                  onChange={(e) =>
                    updateProductData("description", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="details"
                  label="Payout Details"
                  variant="outlined"
                  multiline
                  onChange={(e) =>
                    updateProductData("payout_details", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="eligibilty"
                  label="Eligibilty"
                  variant="outlined"
                  value={eligibiltylist}
                  onChange={(e) => onTextAreaValueChange(e, seteligibiltylist)}
                  onKeyDown={(e) => onKeyPress(e, seteligibiltylist)}
                  wrap="off"
                  multiline
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="rules"
                  label="Rules"
                  variant="outlined"
                  value={ruleslist}
                  onChange={(e) => onTextAreaValueChange(e, setruleslist)}
                  onKeyDown={(e) => onKeyPress(e, setruleslist)}
                  wrap="off"
                  multiline
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="features"
                  label="features"
                  variant="outlined"
                  value={featureslist}
                  onChange={(e) => onTextAreaValueChange(e, setfeatureslist)}
                  onKeyDown={(e) => onKeyPress(e, setfeatureslist)}
                  wrap="off"
                  multiline
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="Steps"
                  label="Steps"
                  variant="outlined"
                  value={steps}
                  onChange={(e) => onTextAreaValueChange(e, setsteps)}
                  onKeyDown={(e) => onKeyPress(e, setsteps)}
                  wrap="off"
                  multiline
                />
              </Grid>
              <Grid item xs={12} sx={{ padding: 5 }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  onClick={(e) => {
                    e.preventDefault();
                    console.log(productData);
                    submitProduct();
                  }}
                >
                  Submit
                </Button>
                <Typography variant="caption" sx={{ color: "red" }}>
                  {error}
                </Typography>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
      <ToastContainer />
    </PageContainer>
  );
}

export default AddProducts;
